<template>
  <div>
<!--    <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'日清报表'}]" />-->
    <Breadtabsheader/>
    <div class="h-content">
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
				<div class="h-thirdColumn">
                    <el-form-item class="h-elformWrap-1" label="拜访日期">
                        <el-col>
                            <el-date-picker
                                    type="daterange"
                                    v-model="times"
                                    unlink-panels
                                    range-separator="-"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd"
                                    width="100%"
                            >
                            </el-date-picker>
                        </el-col>
                    </el-form-item>

					<el-form-item label="创客">
						<el-input v-model="q.cUserCode" placeholder="请输入创客姓名/工号" :clearable="true"></el-input>
					</el-form-item>
<!--                    <el-form-item label="抢入链群">
                        <el-select filterable v-model="q.searchLianqun" clearable placeholder="请选择"
                        >
                            <el-option
                                    v-for="(item,index) in lianqunList"
                                    :key="item.chainGroupCode"
                                    :label="item.chainGroupName"
                                    :value="item.chainGroupCode">
                            </el-option>
                        </el-select>
                    </el-form-item>-->
                    <el-form-item label="抢入链群" prop="lianqun">
                      <brselect category="crm_lianqun" :v="q.searchLianqun" :showcode="true"
                                v-model="q.searchLianqun" clearable></brselect>
                    </el-form-item>
                    <el-form-item label="区域" prop="searchQuyu">
                      <brselect clearable category="show_area" :v="q.searchQuyu"
                                v-model="q.searchQuyu"></brselect>
                    </el-form-item>
          <!--                    <el-form-item label="区域">
                                  <el-select filterable v-model="q.searchQuyu" clearable placeholder="请选择"
                                  >
                                      <el-option
                                              v-for="(item,index) in quyuList"
                                              :key="item.code"
                                              :label="item.name"
                                              :value="item.code">
                                      </el-option>
                                  </el-select>
                              </el-form-item>-->

			  </div>
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="链群类型">
                <el-select filterable v-model="q.lqType" clearable placeholder="请选择"
                >
                  <el-option label="创单链群" value="0"></el-option>
                  <el-option label="体验链群" value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="部门">
                <el-select filterable v-model="q.cdept" clearable placeholder="请选择"
                >
                  <el-option
                      v-for="(item,index) in deptList"
                      :key="item.dept"
                      :label="item.dept"
                      :value="item.dept">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="h-formBtnOut h-columnCenter">
				<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
				<el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>

            </div>
          </el-form>
        </div>
      </div>
      <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
        <el-table
          ref="multipleTable"

          :data="tableData"
          :border="true"
          stripe
          :render-header="renderHeader"
		  max-height="560"
          style="width: 100%"
          >
            <el-table-column prop="user_name" fixed label="创客" width="80" ></el-table-column>
            <el-table-column prop="lianqun_name" fixed label="抢入链群" width="80" ></el-table-column>
            <el-table-column prop="quyu_name" fixed label="区域" width="80" ></el-table-column>
          <el-table-column prop="deptName" fixed label="部门" width="80" ></el-table-column>

            <el-table-column :label="item" v-for="(item, index) in header" :key="item" width="160"  align="center">
                <template slot-scope="scope">
                    <el-tooltip placement="top">
                        <div slot="content"><pre  align="left" style="max-width: 500px;white-space: pre-wrap">{{scope.row[item]}}</pre></div>
                        <div>
                            <pre align="left" style="max-height: 30px">{{scope.row[item]}}</pre></div>
                    </el-tooltip>
                </template>
            </el-table-column>
<!--            <el-table-column prop="userName" label="创客" width="70"></el-table-column>-->
<!--            <el-table-column prop="lianqunName" label="抢入链群" width="80" ></el-table-column>-->

<!--            <el-table-column prop="mc" :label="mclabel"  width="150" :show-overflow-tooltip="true">-->
<!--                <template slot-scope="scope">-->
<!--                    <el-tooltip placement="top">-->
<!--                        <div slot="content"><pre align="left"  style="max-width: 500px;" >{{scope.row.mc}}</pre></div>-->
<!--                        <pre align="left" >{{scope.row.mc}}</pre>-->
<!--                    </el-tooltip>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column prop="wc" label="本周目标" align="left" width="150" >-->
<!--                <template slot-scope="scope">-->
<!--                    <el-tooltip placement="top">-->
<!--                        <div slot="content"><pre align="left"  style="max-width: 500px;">{{scope.row.wc}}</pre></div>-->
<!--                        <pre align="left" >{{scope.row.wc}}</pre>-->
<!--                    </el-tooltip>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column prop="visitContent" :label="vclabel"  width="150" >-->
<!--                <template slot-scope="scope">-->
<!--                    <el-tooltip placement="top">-->
<!--                        <div slot="content"><p  align="left">{{scope.row.customerName}}</p>-->
<!--                            <pre  align="left" style="max-width: 500px;">{{scope.row.visitContent}}</pre></div>-->
<!--                        <div><p align="left">{{scope.row.customerName}}</p>-->
<!--                            <pre align="left">{{scope.row.visitContent}}</pre></div>-->
<!--                    </el-tooltip>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column prop="dc" :label="dclabel"  :show-overflow-tooltip="true">-->
<!--                <template slot-scope="scope">-->
<!--                    <el-tooltip placement="top">-->
<!--                        <div slot="content"><pre align="left"  style="max-width: 500px;">{{scope.row.dc}}</pre></div>-->
<!--                        <pre align="left" >{{scope.row.dc}}</pre>-->
<!--                    </el-tooltip>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column prop="co" label="预实差分析"  width="160">-->
<!--                <template slot-scope="scope">-->
<!--&lt;!&ndash;                    <el-input class="h-tableInput" v-model="scope.row.comment" :clearable="true"></el-input>&ndash;&gt;-->
<!--                    <el-input v-if="scope.row.id " type="textarea" v-model="scope.row.co" placeholder="请输入" class="h-txtareaBox" rows = "4" ></el-input>-->
<!--                </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column prop="sysScore" label="评价"  width="100" :show-overflow-tooltip="true">-->
<!--                <template slot-scope="scope">-->
<!--                    <brselect v-if="scope.row.id " class="h-tableInput" category="userCareLevel" :v="scope.row.sysScore" v-model="scope.row.sysScore"/>-->
<!--                </template>-->
<!--            </el-table-column>-->


<!--          <el-table-column-->
<!--            label="操作"-->
<!--            fixed="right"-->
<!--            width="150"-->
<!--          >-->
<!--            <template slot-scope="scope">-->
<!--				<div style="text-align: left;">-->
<!--					<el-button-->
<!--					   type="text"-->
<!--					   size="small"-->
<!--					   class="h-tableLink h-btn"-->
<!--					   @click="showDetail(scope.row.id)"-->
<!--					 >查看</el-button>-->
<!--                    <el-button-->
<!--                            type="text"-->
<!--                            size="small"-->
<!--                            class="h-tableLink h-btn"-->
<!--                            @click="updateDetail(scope.row.id)"-->
<!--                    >编辑</el-button>-->
<!--                    <el-button-->
<!--                            type="text"-->
<!--                            size="small"-->
<!--                            style="padding: 0;"-->
<!--                            class="h-tableLink h-btn"-->
<!--                            @click="del(scope.row.id)">-->
<!--                        删除-->
<!--                    </el-button>-->
<!--                </div>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query" />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import util from "../../../utils/util";
import customerDetailsService from "../../../api/loud/credit/customerDetailsService";
export default {
  data() {
    return {
        mclabel :'',
        dclabel:'',
        vclabel:'',
        defaultDate :new Date().getFullYear()+"-"+(new Date().getMonth()+1)+"-"+(new Date().getDate()-1),
      //表单
      q: {
          searchDate:new Date().getFullYear()+"-"+(new Date().getMonth()+1)+"-"+(new Date().getDate()-1),
          pageSize: 10,
          pageNo: 1,
          total:0,
          cdept:'',
      },
      add:{
          year :new Date().getFullYear(),
          type : 2,
          month :new Date().getMonth()+2
      },
      times:[],
      isfb:1,
      showhistory:false,
      instid:null,
      pingfen:'暂无',
      paiming:'暂无',
      //表格
      multipleSelection: [],
      multipleSelectionDialog:[],
      tableData: [],
        lianqunList : [],
      //发布排行
      dialogFlag:false,
        spanArr: [],
      sumRank:[],
        yearList:[new Date().getFullYear(),new Date() .getFullYear()+1],
        qyearList:[],
        typeList:[{type:1,text:'月目标'},{type:2,text:'周目标'}],
        monthList:[1,2,3,4,5,6,7,8,9,10,11,12],
        weekList :[],
        quyuList:[],
        deptList: [],
        header:[],
        qweekList :[],
        newDialog: false,
        showDialog:false,
        updateDialog:false,
        showloading:false,
        updateloading:false,
      nosum:'',
      nosoc:'',
      q2: {
          pageSize: 10,
          pageNo: 1,
          total:0,
          rqstatus:'',
      },

    };
  },
  created() {
      this.getAllLianqun();
      this.getQuyu();
      this.getDefaultDate();
      this.getDept();

  },
    beforeRouteLeave(to, from, next) {
        from.meta.keepAlive = false;
        next();
    },
    methods: {

    genzongLiuch(r){
      this.instid = r.instid;
      this.showhistory = true;
    },
    //表格
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //弹框表格
    handleSelectionChangeDialog(val){
      this.multipleSelectionDialog = val;
    },
        renderHeader(h, { column, $index }) {
            return h("div", {
                attrs: {
                    class: "cell" //ele原来样式
                },
                domProps: {
                    innerHTML: '<span class="red">* </span>' + column.label
                }
            });
        },
        //调整评分
        saveGrade(){

            ss.RiqPingj.tzGrade({"evalList":this.tableData}).then(rd => {
                this.$msg.msgs("调整保存成功");
                this.query();
            })


        },
        del(id){
            this.$confirm("确定要删除吗？", '提示')
                .then(_ => {
                    ss.MuBiao.del({id:id}).then(response => {
                        this.query();
                        this.$message({
                            type: "success",
                            message: response.msg
                        });
                    })
                })
                .catch(_ => {
                })
        },
        getLianqun(q){
            ss.createMonthGoal.getLianqun(q).then(rd => {
                this.lianqunList = rd;
            })
        },
        getAllLianqun(){
            ss.createMonthGoal.getAllLianqun().then(rd => {
                this.lianqunList = rd;
            })
        },
        getQuyu(){
            ss.RiqPingj.selectAllQuyu().then(rd => {
                this.quyuList = rd;
            })
        },
        getDept(q){
          ss.MuBiao.getDeptList(q).then(rd => {
            this.deptList = rd;
          })
        },
        showDetail(id){
            this.showDialog = true;
            this.showloading = true;
            ss.MuBiao.selectById({id:id}).then(rd => {
                this.add = rd.obj;
                this.showloading = false;
            });
        },
        updateDetail(id){
            this.updateDialog = true;
            this.updateloading = true;
            ss.MuBiao.selectById({id:id}).then(rd => {
                this.add = rd.obj;
                this.updateloading = false;
            });
        },
        query(){
            if(this.times && this.times.length>0){
                this.q.dateS = this.times[0];
                this.q.dateE = this.times[1];
            }else{
                this.q.dateS = "";
                this.q.dateE = "";
            }

           this.mclabel = new Date(this. q.searchDate).getMonth()+1+'月目标'
            this.dclabel = new Date(this. q.searchDate).getMonth()+1+"月"+new Date(this. q.searchDate).getDate()+"日日清"
            this.vclabel = new Date(this. q.searchDate).getMonth()+1+"月"+new Date(this. q.searchDate).getDate()+"日计划"
            ss.RiqPingj.selectReportTitles(this.q).then(ad => {
                this.header = [];
                if(ad.length>0){
                    for(let i =0;i<ad.length;i++){
                         if(ad[i][i+""] != 'user_name' && ad[i][i+""] != 'lianqun_name' && ad[i][i+""] != 'quyu_name')
                            this.header.push(ad[i][i+""]);
                    }
                }
                ss.RiqPingj.reportPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                });
            });
        },
        getSpanArr() {
            this.spanArr = [];
            this.tableData.forEach((item, index) => {
                if (index === 0) {
                    this.spanArr.push(1);
                    this.position = 0;
                } else {
                    if (this.tableData[index].id && this.tableData[index].id === this.tableData[index - 1].id) {
                        this.spanArr[this.position] += 1;
                        this.spanArr.push(0);
                    } else {
                        this.spanArr.push(1);
                        this.position = index;
                    }
                }
            })

        },
        objectSpanMethod({row, column, rowIndex, columnIndex}) {

            // if ((column.label == '订单编号' || column.label == 'SAP订单号' || column.label == '经销商编码' || column.label == '经销商名称') && row.orderCategory == '2') {
            //     const _row = this.spanArr[rowIndex];
            //     const _col = _row > 0 ? 1 : 0;
            //     return {
            //         rowspan: _row,
            //         colspan: _col
            //     }
            // }else if ((column.label == '订单状态' || column.label == '操作') &&
            //     (row.status == '10' || row.orderCategory == '2')) {
            //     const _row = this.spanArr[rowIndex];
            //     const _col = _row > 0 ? 1 : 0;
            //     return {
            //         rowspan: _row,
            //         colspan: _col
            //     }
            // } == this.mclabel
            //if(column.label == '抢入链群'|| column.label == '创客'
            if(columnIndex !=5 && columnIndex !=6

                // || column.label.indexOf("月目标") != -1  || column.label == '本周目标'|| column.label == '评价'
                //  || column.label == '预实差分析'
                ){
                console.log(column.label);
                const _row = this.spanArr[rowIndex];

                const _col = _row > 0 ? 1 : 0;
                //console.log("_row:"+_row+"-_col:"+_col)
                return {
                    rowspan: _row,
                    colspan: _col
                }
            }

        },
        create(){

            this.newDialog = true;
        },
//取消按钮
        exit() {
            this.newDialog = false;
            this.showDialog = false;
            this.updateDialog = false;
        },
    handleFilter() {
      this.query();
    },
    checkRank() {
      this.$router.push("/paiming");
    },

    typeIndex(index){
      return index+(this.q2.pageNo-1)*this.q2.pageSize+1;
    },

    //明细导出
			exportExcel() {
                updownfile.down("/api/swyl/v1/riqing/userDailyEval/downloadReportExcel",this.q,"post",'data');
      },

    //重置
    rest() {
      var pageSize=this.q.pageSize;
      var pageNo=this.q.pageNo;
      var total=this.q.total;
      this.q= {
          pageSize: pageSize,
          pageNo: pageNo,
          total:total,
      }
    },

        getDefaultDate() {
                //获取新的时间(2019.4.12）
                let date = new Date()
                //获取当前时间的年份转为字符串
                let year = date.getFullYear().toString()   //'2019'
                //获取月份，由于月份从0开始，此处要加1，判断是否小于10，如果是在字符串前面拼接'0'
                let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString()  //'04'
                //获取天，判断是否小于10，如果是在字符串前面拼接'0'
                let da = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString()  //'12'
                //字符串拼接，开始时间，结束时间
                let end = year + '-' + month + '-' + this.getLastDate(year,month)  //当天'2019-04-12'
                let beg = year + '-' + month + '-01'   //当月第一天'2019-04-01'
                this.times = [beg, end] //将值设置给插件绑定的数据
            },
            getLastDate(iYear,iMonth){

                if (iMonth == '02')
                    if (!iYear % '04')
                        return 29;
                    else return 28
                else if (iMonth == '04' || iMonth == '06' || iMonth == '09' || iMonth == 11)
                    return 30;
                else  return 31;
            },
        },

  mounted() {
    this.query();

  }
};
</script>

<style>
</style>
<style>
    .chosedialog .body_dilog{
        padding-top: 0px!important;
    }
    .chosedialog .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .chosedialog .el-dialog__body{
        padding: 0px 20px!important;
    }
    .chosedialog .h-pagination{
        padding-top:0px !important;
        padding-bottom:0px !important;
    }
	.ljjcaozuo .el-button [class*=el-icon-]+span{
		margin-left: 0;
	}
	.ljjcaozuo .h-el-icon{
		margin-right: 0;
	}
	.smTableRq .el-table tbody td .cell {
	    padding-top: 0.03rem;
	    padding-bottom: 0.03rem;
	}
	.smTableRq .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.smTableRq .el-input__inner{
		background: transparent;
	}
	.ljjtablepaddingsrq .h-tableInput{
		margin-top: 0.05rem;
	}
	.ljjtablepaddingsrq .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
		color: #616467;
		font-size: 0.16rem;
	}
	.ljjtablepaddingsrq .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}

    .X-dai .h-formbLine .h-elformWrap-2 {
        padding-right: 0.5rem;
        width: 50% !important;
    }
    .X-dai .h-formbLine .h-elformWrap-3 {
        padding-right: 0.5rem;
        width: 47% !important;
    }
    .X-dai .h-formbLine .h-elformWrap-1 {
        padding-right: 0;
        width: 100% !important;
    }
    .X-dai .h-formbLine .h-elformWrap-1 .el-form-item__label{
        width: 22%;
    }
    .X-dai .h-formbLine .h-elformWrap-1 .el-form-item__content{
        width: 78%;
    }
    .X-dai .h-formbLine .h-elformWrap-3 .el-form-item__label{
        width: 16%;
    }
    .X-dai .h-formbLine .h-elformWrap-3 .el-form-item__content{
        width: 82%;
    }
    .X-dai .h-formbLine .el-form-item__label {
        width: 51%;

    }
    .X-dai .h-formbLine .el-form-item__content {
        width: 49%;
    }
    pre {
        display: block;
        font-family: inherit;
        white-space: pre-wrap;
        white-space: -moz-pre-wrap;
        white-space: -o-pre-wrap;
        word-wrap: break-word;
        padding: 0;
        margin: 0;
        line-height: inherit;
        color: inherit;
        word-break: break-all;
        background-color: transparent;
        border: none;
        border-radius: 0;
    }
</style>
